var map = {
	"./HelloWorld.vue": "gORT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uo3w";


//////////////////
// WEBPACK FOOTER
// ./src/components \w+\.(vue|js)$
// module id = Uo3w
// module chunks = 10